import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import Loading from "../general/Loading";
import Swal from 'sweetalert2';
import DataTable from "react-data-table-component";

function UsuariosSispro() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [tienePermiso, setTienePermiso] = useState(false);
    const [terminoBusqueda, setTerminoBusqueda] = useState('');
    const [idItemEliminar, setIdItemEliminar] = useState();
    const [modalContainerStatus, setModalContainerStatus] = useState('');
    const [modalBackdropStatus, setModalBackdropStatus] = useState('zindex-back');
    const [toastMsg, setToastMsg] = useState('');
    const [showModalAcciones, setShowModalAcciones] = useState(false);
    const [itemAccion, setItemAccion] = useState(null);
    const [probandoConexion, setProbandoConexion] = useState(false);
    let userdata = [];

    const cols = [
        { name: 'Nombre', selector: row => row.nombre, sortable: true },
        { name: 'Tipo Doc.', selector: row => row.tipo_documento, sortable: true },
        { name: 'Identificación', selector: row => row.identificacion, sortable: true },
        { name: 'Tipo SISPRO', selector: row => row.tipo_usuario || 'PIN', sortable: true },
        { name: 'Usuario Responsable', selector: row => getNombreUsuario(row.users_id), sortable: true },
        { name: 'Config.', cell: row => (
            <span className={`badge ${row.estado === 1 ? 'badge-success' : 'badge-warning'}`}>
                {row.estado === 1 ? 'Listo' : 'Pendiente'}
            </span>
        ), sortable: true },
        { name: 'Estado', cell: row => getEstadoBadge(row), sortable: true },
        {
            name: '',
            cell: row => (
                <button
                    type="button"
                    className="btn btn-sm btn-light shadow-sm"
                    onClick={() => abrirModalAcciones(row)}
                    disabled={!tienePermiso}
                    style={{
                        borderRadius: '8px',
                        padding: '4px 12px',
                        background: 'white',
                        color: '#323a45',
                        border: '1px solid #f0f0f0',
                        opacity: tienePermiso ? 1 : 0.5,
                    }}
                    title={tienePermiso ? 'Opciones' : 'Sin permiso'}
                >
                    <i className="fas fa-ellipsis-v"></i>
                </button>
            ),
            width: '56px',
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const getEstadoBadge = (item) => {
        return (
            <span
                className={`badge ${item.activo === 1 ? 'badge-success' : 'badge-secondary'}`}
                style={{
                    cursor: tienePermiso ? 'pointer' : 'default',
                    opacity: tienePermiso ? 1 : 0.7,
                }}
                onClick={() => tienePermiso && toggleActivo(item.id, item.activo)}
                title={tienePermiso ? 'Click para cambiar estado' : 'No tiene permisos para cambiar estado'}
            >
                {item.activo === 1 ? 'Activo' : 'Inactivo'}
            </span>
        );
    };

    useEffect(() => {
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        let permiso = false;
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            permiso = userdata.permissions.some(permission => permission.slug === 'enviarRipsSispro');
        } else if (userdata.up && userdata.up.includes('enviarRipsSispro')) {
            permiso = true;
        }
        setTienePermiso(permiso);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
            },
        };

        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('Error:', error);
            });

        axios.get('/sispro-users?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setItems(response.data);
                }
            })
            .catch(error => {
                console.error('Error al cargar usuarios SISPRO:', error);
            });

        axios.get('/usuarios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('Error al cargar usuarios:', error);
            });
    }, []);

    useEffect(() => {
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
            },
            params: {
                uid: userdata.user_id,
                termino: terminoBusqueda,
            },
        };

        axios.get('/sispro-users', config)
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, [terminoBusqueda]);

    const getNombreUsuario = (usersId) => {
        if (!usersId) return '-';
        const usuario = usuarios.find(u => u.id === usersId);
        return usuario ? `${usuario.name} ${usuario.lastname}` : '-';
    };

    const abrirModalAcciones = (item) => {
        setItemAccion(item);
        setShowModalAcciones(true);
    };

    const cerrarModalAcciones = () => {
        setShowModalAcciones(false);
        setItemAccion(null);
    };

    const showModalEliminar = () => {
        if (!itemAccion) return;
        cerrarModalAcciones();
        setModalContainerStatus('show');
        setModalBackdropStatus('show');
        setIdItemEliminar(itemAccion.id);
    };

    const cerrarEliminar = () => {
        setModalContainerStatus('');
        setModalBackdropStatus('zindex-back');
        setIdItemEliminar(null);
    };

    const eliminar = (id) => {
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
            },
            params: {
                id: id,
            },
        };

        axios.delete('/sispro-user?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    const nuevoItems = items.filter((it) => it.id !== id);
                    const eliminado = items.find((it) => it.id === id);
                    setItems(nuevoItems);
                    cerrarEliminar();
                    setToastMsg('El Usuario SISPRO ' + (eliminado ? eliminado.nombre : '') + ' Se Eliminó Con ÉXITO');
                }
            })
            .catch(error => {
                console.log(error);
                cerrarEliminar();
            });
    };

    const formatearErrorSispro = (errors) => {
        if (errors === null || errors === undefined) return '';
        if (typeof errors === 'string') return errors;
        if (Array.isArray(errors)) return errors.join('\n');
        if (typeof errors === 'object') {
            return Object.values(errors).flat().join('\n');
        }
        return String(errors);
    };

    const probarConexion = async () => {
        if (!itemAccion || probandoConexion) return;

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        setProbandoConexion(true);
        cerrarModalAcciones();

        Swal.fire({
            title: 'Probando conexión SISPRO...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        try {
            const response = await axios.post(
                `/sispro-user/${itemAccion.id}/probar-conexion`,
                {},
                {
                    headers: {
                        Authorization: 'Bearer ' + userdata.access_token,
                    },
                }
            );

            const { login, registrado, errors } = response.data || {};

            if (login && registrado) {
                await Swal.fire({
                    icon: 'success',
                    title: 'Conexión exitosa',
                    html: `
                        <p class="mb-2">Usuario <strong>${itemAccion.nombre}</strong> autenticado en SISPRO.</p>
                        <p class="font-weight-bold text-muted small mb-1">Respuesta de la Plataforma de SISPRO:</p>
                        <ul class="text-left small mb-0 pl-3">
                            <li><strong>login:</strong> true</li>
                            <li><strong>registrado:</strong> true</li>
                            <li><strong>errors:</strong> null</li>
                        </ul>
                    `,
                    confirmButtonText: 'Aceptar',
                });
            } else {
                await Swal.fire({
                    icon: 'error',
                    title: 'Error al Ingresar a SISPRO',
                    html: `
                        <p class="mb-2">Valida Información del Usuario, o Verifica en Mi Seguridad Social.</p>
                        <p class="font-weight-bold text-muted small mb-1">Respuesta de la Plataforma de SISPRO:</p>
                        <ul class="text-left small mb-0 pl-3">
                            <li><strong>login:</strong> ${login ? 'true' : 'false'}</li>
                            <li><strong>registrado:</strong> ${registrado ? 'true' : 'false'}</li>
                            <li><strong>errors:</strong> ${errors ? formatearErrorSispro(errors) : 'null'}</li>
                        </ul>
                    `,
                    confirmButtonText: 'Aceptar',
                });
            }
        } catch (error) {
            const data = error.response?.data;

            await Swal.fire({
                icon: 'error',
                title: 'Error al Ingresar a SISPRO',
                html: `
                    <p class="mb-2">Valida Información del Usuario, o Verifica en Mi Seguridad Social.</p>
                    ${data ? `<p class="font-weight-bold text-muted small mb-1">Respuesta de la Plataforma de SISPRO:</p><pre class="text-left small mb-0 p-2 bg-light rounded" style="white-space: pre-wrap;">${JSON.stringify(data, null, 2)}</pre>` : ''}
                `,
                confirmButtonText: 'Aceptar',
            });
        } finally {
            setProbandoConexion(false);
        }
    };

    const toggleActivo = (id, activoActual) => {
        const nuevoEstado = activoActual === 1 ? 0 : 1;

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
            },
        };

        axios.put('/sispro-user/' + id, { activo: nuevoEstado }, config)
            .then(() => {
                const nuevosItems = items.map(item => {
                    if (item.id === id) {
                        return { ...item, activo: nuevoEstado };
                    }
                    return item;
                });
                setItems(nuevosItems);
                setToastMsg(`Usuario SISPRO ${nuevoEstado === 1 ? 'activado' : 'desactivado'} exitosamente`);
            })
            .catch(error => {
                console.error('Error al cambiar estado:', error);
            });
    };

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item"><Link to="/personal-proveedores">Personal y Proveedores</Link></li>
                                        <li className="breadcrumb-item active">Usuarios SISPRO</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Usuarios SISPRO</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row" style={{ marginBottom: '30px' }}>
                                <div className="col-md-9">
                                    <Link
                                        to="/nuevo-usuario-sispro"
                                        className="btn btn-primary"
                                        style={{ pointerEvents: tienePermiso ? 'auto' : 'none', opacity: tienePermiso ? 1 : 0.5 }}
                                        title={!tienePermiso ? 'No tiene permisos para crear usuarios SISPRO' : ''}
                                    >
                                        Crear Nuevo Usuario SISPRO
                                    </Link>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="terminoBusqueda">Buscar</label>
                                        <input
                                            type="text"
                                            name="terminoBusqueda"
                                            className="form-control"
                                            id="terminoBusqueda"
                                            onChange={(e) => setTerminoBusqueda(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <DataTable
                                        columns={cols}
                                        data={items}
                                        pagination
                                        paginationComponentOptions={{
                                            rowsPerPageText: 'Filas por página:',
                                            rangeSeparatorText: 'de',
                                            noRowsPerPage: false,
                                            selectAllRowsItem: true,
                                            selectAllRowsItemText: 'Todos',
                                        }}
                                        noDataComponent="No hay registros para mostrar"
                                        id="usuarios_sispro"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                {showModalAcciones && itemAccion && (
                    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
                        <div className="modal-dialog modal-dialog-centered modal-sm">
                            <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px', overflow: 'hidden' }}>
                                <div className="modal-header border-0 pb-0" style={{ background: '#f8f9fa' }}>
                                    <h6 className="modal-title font-weight-bold text-truncate" style={{ color: '#323a45', maxWidth: '85%' }}>
                                        {itemAccion.nombre}
                                    </h6>
                                    <button type="button" className="close" onClick={cerrarModalAcciones}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body p-3">
                                    <div className="list-group list-group-flush">
                                        <Link
                                            to={`/editar-usuario-sispro?id=${itemAccion.id}`}
                                            className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                            style={{ borderRadius: '12px' }}
                                            onClick={cerrarModalAcciones}
                                        >
                                            <i className="fas fa-edit mr-3 text-info"></i>
                                            <span style={{ fontWeight: 600 }}>Editar</span>
                                        </Link>
                                        <button
                                            type="button"
                                            className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                            style={{ borderRadius: '12px', background: 'rgba(23, 162, 184, 0.08)' }}
                                            onClick={probarConexion}
                                            disabled={probandoConexion}
                                        >
                                            <i className={`fas ${probandoConexion ? 'fa-spinner fa-spin' : 'fa-plug'} mr-3 text-info`}></i>
                                            <span style={{ fontWeight: 600 }}>Probar conexión</span>
                                        </button>
                                        <button
                                            type="button"
                                            className="list-group-item list-group-item-action border-0 d-flex align-items-center text-danger"
                                            style={{ borderRadius: '12px' }}
                                            onClick={showModalEliminar}
                                        >
                                            <i className="fas fa-trash-alt mr-3"></i>
                                            <span style={{ fontWeight: 600 }}>Eliminar</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className={'modal-container modal fade in ' + modalContainerStatus}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Eliminar Usuario SISPRO</h4>
                                <button type="button" className="close" onClick={() => cerrarEliminar()}>&times;</button>
                            </div>
                            <div className="modal-body">
                                ¿Está seguro que desea eliminar el usuario SISPRO seleccionado?
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => cerrarEliminar()}>Cancelar</button>
                                <button type="button" className="btn btn-danger" onClick={() => eliminar(idItemEliminar)}>Eliminar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'modal-backdrop fade ' + modalBackdropStatus}></div>

                <Footer showToast={false} delay={0} message={toastMsg} />
            </div>
        );
    }

    return <Loading />;
}

export default UsuariosSispro;
